import {
  InsuranceCoverage,
  InsuranceCoverageCreate,
  InsuranceCoverageUpdate,
} from "@/types/insurance-coverage";

import { requestData } from "@/api/api-config";

export async function listInsuranceCoverages(
  patientId: string,
): Promise<InsuranceCoverage[] | null> {
  return await requestData<InsuranceCoverage[]>(
    `user/patient/${patientId}/insurance-coverages`,
    "get",
  );
}

export async function createInsuranceCoverage(
  patientId: string,
  body: InsuranceCoverageCreate,
): Promise<InsuranceCoverage | null> {
  return await requestData<InsuranceCoverage>(
    `user/patient/${patientId}/insurance-coverages`,
    "post",
    { json: body },
    false,
  );
}

export async function updateInsuranceCoverage(
  patientId: string,
  coverageId: string,
  body: InsuranceCoverageUpdate,
): Promise<InsuranceCoverage | null> {
  return await requestData<InsuranceCoverage>(
    `user/patient/${patientId}/insurance-coverages/${coverageId}`,
    "put",
    { json: body },
    false,
  );
}

export async function deleteInsuranceCoverage(
  patientId: string,
  coverageId: string,
): Promise<boolean | null> {
  return await requestData<boolean>(
    `user/patient/${patientId}/insurance-coverages/${coverageId}`,
    "delete",
    {},
    false,
  );
}
